"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _kebabCase = _interopRequireDefault(require("lodash/kebabCase"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _PortalContent = _interopRequireDefault(require("../Portal/PortalContent"));
var _mixins = require("../mixins");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var propTypes = {
  /**
   * Specify first item that is active, by passing in the value of the tab
   * Will default to first tab
   * Is ignored when activeTab is passed in
   */
  initialActive: _propTypes["default"].string,
  /**
   * Function to execute when a tab is clicked
   * Function receives the tab value or index (when there isn't a value prop passed to the tab)
   * Required if you are using controlled tabs
   */
  onTabClick: _propTypes["default"].func,
  /** Gives parent component control over which tab is active
   * Passing this prop will transform the Tabs into a *Controlled* component
   * Make sure you pass in "onTabClick"
   * Will be used instead of initialActive
   */
  activeTab: _propTypes["default"].string,
  /** When `true` add in panels that change based on the currently active tab
   * @default: true
   */
  withPanels: _propTypes["default"].bool,
  /** Child tabs */
  children: _propTypes["default"].any,
  /** When `true` only current tab is rendered
   * @default: false
   */
  onlyRenderActive: _propTypes["default"].bool,
  /**
   * When an `id` is passed, the tabs content will be rendered with Portal in a div that has this id;
   * Do not forget to add the container in the page, where you whish to display the content
   */
  portalInContainerWithID: _propTypes["default"].string,
  /** Styles variants for the tabs  */
  positioning: _propTypes["default"].oneOf(["top", "left", "topFixed"]),
  /** Styles variants for the tabs  */
  variant: _propTypes["default"].oneOf(["normal", "narrow"]),
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string
};

/* Styled components ************************************ */

var TabsList = _styledComponents["default"].ul.withConfig({
  displayName: "Tabs__TabsList",
  componentId: "sc-67mcei-0"
})(["", ";display:flex;align-items:flex-end;border-bottom:1px solid ", ";flex-wrap:wrap;", " ", ";"], _mixins.listBareMixin, function (props) {
  return props.theme.colors.border;
}, function (props) {
  return props.variant === "narrow" && (0, _styledComponents.css)(["padding-left:calc( ", " - ", " );padding-right:calc( ", " - ", " );"], function (props) {
    return props.theme.layouts.p;
  }, function (props) {
    return props.theme.tabs.pH;
  }, function (props) {
    return props.theme.layouts.p;
  }, function (props) {
    return props.theme.tabs.pH;
  });
}, function (props) {
  return props.positioning === "left" && (0, _styledComponents.css)(["flex-shrink:0;flex-direction:column;background-color:", ";padding-left:0;padding-right:0;align-items:flex-start;width:", ";height:100%;position:relative;border-bottom:none;&::before{content:\"\";position:absolute;top:0;right:0;width:1px;height:100%;background-color:", ";}"], props.theme.colors.backgroundSecondary, props.width || "200px", props.theme.colors.border);
});
TabsList.displayName = "TabsList_SC";
var TabButton = _styledComponents["default"].li.withConfig({
  displayName: "Tabs__TabButton",
  componentId: "sc-67mcei-1"
})(["display:flex;font-size:", ";padding:", " ", ";color:", ";cursor:pointer;position:relative;&:focus,&:hover{outline:none;color:", ";}", ";", ";", " ", ""], function (props) {
  return props.theme.tabs.fontSize;
}, function (props) {
  return props.theme.spaces.base;
}, function (props) {
  return props.theme.tabs.pH;
}, function (props) {
  return props.theme.colors[props.theme.tabs.color];
}, function (props) {
  return props.theme.colors[props.theme.tabs.hoverColor];
}, function (props) {
  return props.disabled && (0, _styledComponents.css)(["cursor:not-allowed;color:", ";&:focus,&:hover{color:", ";}"], props.theme.colors[props.theme.tabs.disabledColor], props.theme.colors[props.theme.tabs.disabledColor]);
}, function (props) {
  return props.isActive && (0, _styledComponents.css)(["color:", ";font-weight:", ";&::after{content:\"\";width:100%;height:2px;position:absolute;bottom:-1px;left:0;z-index:", ";background-color:", ";}"], props.theme.colors[props.theme.tabs.activeColor], props.theme.fontWeights.semibold, props.theme.zIndex.above, props.theme.colors.focus);
}, function (props) {
  return props.variant === "narrow" && (0, _styledComponents.css)(["", ""], props.isActive && (0, _styledComponents.css)(["&::after{width:calc(100% - ", " * 2);left:", ";}"], props.theme.tabs.pH, props.theme.tabs.pH));
}, function (props) {
  return props.positioning === "left" && (0, _styledComponents.css)(["padding:", ";background-color:transparent;width:100%;", ""], props.theme.spaces.base, props.isActive && (0, _styledComponents.css)(["box-shadow:none;background-color:", ";border-right:1px solid ", ";&::after{display:none;}"], props.theme.colors.backgroundPrimary, props.theme.colors.focus));
});
var PanelsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Tabs__PanelsWrapper",
  componentId: "sc-67mcei-2"
})(["width:100%;", ""], function (props) {
  return (props.positioning === "left" || props.positioning === "topFixed") && (0, _styledComponents.css)(["overflow-y:auto;"]);
});
PanelsWrapper.displayName = "PanelsWrapper_SC";

/** Wrapper for the entire component: TabsList & Panels  */
var TabsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Tabs__TabsWrapper",
  componentId: "sc-67mcei-3"
})(["display:flex;flex-direction:column;width:100%;", " ", ""], function (props) {
  return props.positioning === "left" && (0, _styledComponents.css)(["flex-direction:row;"]);
}, function (props) {
  return (props.positioning === "left" || props.positioning === "topFixed") && (0, _styledComponents.css)(["height:100%;overflow:hidden;"]);
});
TabsWrapper.displayName = "TabsWrapper_SC";

/* Tabs Component ************************************ */

var Tabs = function Tabs(_ref) {
  var initialActive = _ref.initialActive,
    onTabClick = _ref.onTabClick,
    activeTab = _ref.activeTab,
    _ref$withPanels = _ref.withPanels,
    withPanels = _ref$withPanels === void 0 ? true : _ref$withPanels,
    children = _ref.children,
    _ref$positioning = _ref.positioning,
    positioning = _ref$positioning === void 0 ? "top" : _ref$positioning,
    variant = _ref.variant,
    _ref$onlyRenderActive = _ref.onlyRenderActive,
    onlyRenderActive = _ref$onlyRenderActive === void 0 ? false : _ref$onlyRenderActive,
    portalInContainerWithID = _ref.portalInContainerWithID,
    automationHook = _ref.automationHook;
  var theme = (0, _styledComponents.useTheme)();
  variant = variant || theme.tabs.variant;
  var _useState = (0, _react.useState)(activeTab || initialActive),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var isControlled = typeof activeTab !== "undefined";
  var WrapperInner = portalInContainerWithID ? _PortalContent["default"] : PanelsWrapper;
  var wrapperProps = portalInContainerWithID ? {
    containerId: portalInContainerWithID
  } : {};
  var isActiveTab = function isActiveTab(value, index) {
    if (typeof active !== "undefined") {
      return active === value;
    }
    return index === 0;
  };

  // update the internal state when the activeTab changes
  (0, _react.useEffect)(function () {
    if (typeof activeTab !== "undefined") {
      setActive(activeTab);
    }
  }, [activeTab]);
  return children && /*#__PURE__*/_react["default"].createElement(TabsWrapper, {
    positioning: positioning
  }, /*#__PURE__*/_react["default"].createElement(TabsList, _extends({
    positioning: positioning,
    variant: variant
  }, (0, _automationHooks.hook)(automationHook, "tabs-list")), _react["default"].Children.map(children, function (child, index) {
    if (!child) {
      // allow null children
      return null;
    }
    var value = child.props.value || index;
    var onClickProp = child.props.disabled ? {} : {
      onClick: function onClick(event) {
        event.preventDefault();
        if (!isControlled) {
          setActive(value);
        }
        if (typeof onTabClick === "function") {
          onTabClick(value);
        }
      }
    };
    return /*#__PURE__*/_react["default"].createElement(TabButton, _extends({
      key: index,
      isActive: isActiveTab(value, index)
    }, onClickProp, {
      disabled: child.props.disabled,
      variant: variant,
      positioning: positioning
    }, (0, _automationHooks.hook)(automationHook, "".concat(child.props.automationName ? child.props.automationName : (0, _kebabCase["default"])(value), "-tab").concat(isActiveTab(value, index) ? "-active" : ""))), child.props.title);
  })), withPanels && /*#__PURE__*/_react["default"].createElement(WrapperInner, _extends({}, wrapperProps, {
    variant: variant,
    positioning: positioning
  }, (0, _automationHooks.hook)(automationHook, "tabs-content")), _react["default"].Children.map(children, function (child, index) {
    if (!child) {
      // allow null children
      return null;
    }
    var isActive = isActiveTab(child.props.value, index);
    var value = child.props.value || index;
    if (!onlyRenderActive || onlyRenderActive && isActive) {
      return /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread(_objectSpread({
        key: index,
        isActive: isActive
      }, (0, _automationHooks.hook)(automationHook, "".concat(child.props.automationName ? child.props.automationName : (0, _kebabCase["default"])(value), "-content"))), {}, {
        title: undefined
      }));
    }
    return null;
  })));
};
Tabs.propTypes = propTypes;
Tabs.displayName = "Tabs";

/* Exports ****************************************** */
var _default = Tabs;
exports["default"] = _default;